import React, { useEffect, useState } from "react";
import "./Customers.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  AddCustomerDoc,
  DeleteCustomer,
  DeleteCustomerDoc,
  GetCustomerDetails,
} from "../../apis/CustomerAPI";
import { GetCountries, GetStates } from "../../apis/MiscAPI";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import {
  AssignReportTemplate,
  DeleteCustomerReport,
  GetAllReports,
  GetCustomerReport,
  GetReportTemplate,
} from "../../apis/ReportsAPI";
import { UpdatePassword } from "../../apis/LoginAPI";
import { generate } from "@wcj/generate-password";
import {
  AddRequestor,
  AddUpdateRequestorAddress,
  DeleteRequestor,
  DeleteRequestorAddress,
  GetRequestorByMapping,
  UpdateRequestor,
  checkRequesterEmail,
} from "../../apis/RequestorAPI";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { GetBase64, ShowCustomerDocument } from "../../utils/Utility";
import {
  AssignFormTemplateToCustomer,
  DeleteAssignedForm,
  GetAllFormTemplates,
  UpdateAssignedForm,
} from "../../apis/FormAPI";
import { filterBy } from "@progress/kendo-data-query";
import dateFormat from "dateformat";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import * as MdIcons from "react-icons/md";

export default function CustomerViewDetails() {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("id");
  const alert = useAlert();

  const [customerData, setCustomerData] = useState([]);
  const [requestorData, setRequestorData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [reportTemplateData, setReportTemplateData] = useState([]);
  const [docData, setDocData] = useState([]);
  const [oldReportList, setOldReportList] = useState([]);
  const navigate = useNavigate();

  const defaultRequestor = {
    mapping_id: 0,
    requestor_id: 0,
    requestor_name: "",
    requestor_email: "",
    invoice_email: "",
    requestor_phone: "",
    requestor_password: "",
    addresses: [],
  };

  const defaultCountry = {
    countryName: "Choose Country ...",
    countryId: 0,
  };

  const defaultState = {
    stateName: "Choose State ...",
    stateId: 0,
    countryId: 0,
  };

  const defaultAddress = {
    address_id: 0,
    street_address: "",
    street_address2: "",
    city: "",
    statelist: [],
    state: defaultState,
    zipcode: "",
    country: defaultCountry,
    is_deleted: false,
  };

  const [requestor, setRequestor] = useState(defaultRequestor);

  const updateRequestor = (key, value) => {
    setRequestor((prevState) => ({ ...prevState, [key]: value }));
  };

  const [reportId, setReportId] = useState(0);
  const [reportMappingId, setReportMappingId] = useState(0);

  const [reportName, setReportName] = useState("");
  const [reportPrice, setReportPrice] = useState(0);
  const [reportCustomPrice, setReportCustomPrice] = useState(0);
  const [allReport, setAllReport] = useState([]);

  const [formData, setFormData] = useState([]);
  const [formTemplateData, setFormTemplateData] = useState([]);
  const [formName, setFormName] = useState("");
  const [formTemplate, setFormTemplate] = useState([]);
  const [formId, setFormId] = useState(0);

  const [docName, setDocName] = useState("");
  const [docFile, setDocFile] = useState("");

  const [showLoader, setShowLoader] = useState({
    customerDelete: false,
    document: false,
    requestor: false,
    report: false,
    form: false,
    address: false,
  });

  const updateLoader = (key, value) => {
    setShowLoader((prevState) => ({ ...prevState, [key]: value }));
  };

  async function GetCustomerData() {
    var result = await GetCustomerDetails(customerId);
    var data = result.data;

    setCustomerData(data.item1);
    setRequestorData(data.item2);
    setReportData(data.item3);
    setDocData(data.item4);
    setFormData(data.item5);
  }

  useEffect(() => {
    async function GetCountryList() {
      var result = await GetCountries();
      setCountryData(result.data);
    }

    async function GetReportTemplateList() {
      var result = await GetReportTemplate();
      setReportTemplateData(result.data);
    }

    async function GetFormTemplates() {
      var result = await GetAllFormTemplates();
      setFormTemplateData(result.data);
    }

    async function GetReportList() {
      var result = await GetAllReports();
      setOldReportList(result.data.slice());
      setAllReport(result.data.slice());
    }

    async function GetStateList() {
      var result = await GetStates(0);
      setStateData(result.data);
    }

    GetCustomerData();
    GetCountryList();
    GetReportTemplateList();
    GetFormTemplates();
    GetReportList();
    GetStateList();
  }, []);

  const [docShow, setDocShow] = useState(false);
  const handleDocShow = () => {
    setDocName("");
    setDocFile("");
    setDocShow(true);
  };
  const handleDocClose = () => setDocShow(false);

  const [requestorShow, setRequestorShow] = useState(false);
  const handleRequestorClose = () => {
    setRequestor(defaultRequestor);
    setRequestorShow(false);
  };
  const handleRequestorShow = () => setRequestorShow(true);

  const [reportShow, setReportShow] = useState(false);
  const handleReportClose = () => {
    setReportMappingId(0);
    setReportId(0);
    setReportTemplate(defaultReportTemplate);
    setReport("");
    setReportName("");
    setReportPrice(0);
    setReportCustomPrice(0);
    setReportShow(false);
    setReportList(false);
  };
  const handleReportShow = () => setReportShow(true);

  const [formShow, setFormShow] = useState(false);
  const handleFormClose = () => {
    setFormName("");
    setFormTemplate([]);
    setFormId(0);
    setFormShow(false);
  };
  const handleFormShow = () => setFormShow(true);

  const [addressShow, setAddressShow] = useState(false);
  const handleAddressShow = () => setAddressShow(true);
  const handleAddressClose = () => setAddressShow(false);

  const defaultReportTemplate = {
    templateName: "Choose Report Template ...",
    id: 0,
  };
  const [reportTemplate, setReportTemplate] = useState(defaultReportTemplate);

  const defaultFormTemplate = {
    templateName: "Choose Form Template ...",
    id: 0,
  };

  const [report, setReport] = useState([]);

  const handleReport = (item) => {
    let tmplt = reportTemplateData.filter(
      (x) => x.id === item.reportTemplateId
    )[0];
    setReportTemplate(tmplt);
    setReportPrice(item.reportPrice);
    setReport(item);
    setReportName(item.reportName);
  };

  async function resetPassword(ev, useremail) {
    ev.currentTarget.disabled = true;
    var result = await UpdatePassword(useremail);
    alert.success(result.data);
    ev.currentTarget.disabled = false;
  }

  function handleFileChange(event) {
    const file = event.target.files[0];
    if (
      file.size <= 25000000 &&
      !file.type.includes("application/x-msdownload")
    ) {
      GetBase64(file, (result) => {
        setDocFile(result);
      });
    } else alert.error("file must be less than 25Mb");
  }

  async function getRequestorDetail(mappingId) {
    updateRequestor("mapping_id", mappingId);
    var result = await GetRequestorByMapping(mappingId);
    var requestorData = result.data.item1;
    var addresses = result.data.item2;

    for (var prop in requestorData) {
      if (!requestorData.hasOwnProperty(prop)) continue;
      updateRequestor(prop, requestorData[prop]);
    }

    let addrList = [];
    if (addresses != null && addresses.length > 0) {
      for (var addr of addresses) {
        var cntry = countryData.filter((x) => x.countryId == addr.country);
        var addr_state = stateData.filter((x) => x.stateId == addr.STATE);

        if (cntry !== null && cntry.length > 0) {
          var statelist = stateData.filter(
            (x) => x.countryId == cntry[0].countryId
          );
          addr.statelist = statelist;

          addr.country = {
            countryId: cntry[0].countryId,
            countryName: cntry[0].countryName,
          };
          if (addr_state !== null && addr_state.length > 0)
            addr.state = {
              stateId: addr_state[0].stateId,
              stateName: addr_state[0].stateName,
              countryId: cntry[0].countryId,
            };
        }
        addrList.push(addr);
      }
      updateRequestor("addresses", addrList);
    } else {
      addrList.push(defaultAddress);
      updateRequestor("addresses", addrList);
    }

    setRequestorShow(true);
  }

  async function getReportDetail(mappingId) {
    var result = await GetCustomerReport(mappingId);
    var report = result.data;
    setReportId(report.id);
    setReportMappingId(mappingId);
    var template = reportTemplateData.filter(
      (r) => r.id === report.reportTemplateId
    );
    if (template.length === 0) setReportTemplate(defaultReportTemplate);
    else
      setReportTemplate({
        templateName: template[0].templateName,
        id: template[0].id,
      });
    setReportName(report.reportName);
    setReportPrice(report.reportPrice);
    setReportCustomPrice(report.reportPrice);

    setReportShow(true);
  }

  const saveRequestor = async (evt) => {
    evt.preventDefault();
    if (saveRequestorValidate()) {
      var data = {
        id: requestor.requestor_id,
        totalRows: 0,
        customerId: customerId,
        requestorName: requestor.requestor_name,
        emailAddress: requestor.requestor_email,
        invoiceEmail: requestor.invoice_email,
        phoneNumber: requestor.requestor_phone,
        password:
          requestor.requestor_password !== undefined &&
          requestor.requestor_password !== ""
            ? requestor.requestor_password
            : "",
        requestorAddresses: getRequestorAddresses(),
      };

      if (requestor.requestor_id === 0) {
        updateLoader("requestor", true);
        var result = await AddRequestor(data);
        updateLoader("requestor", false);
        if (result.data === 0) alert.error("Unable to add requester");
        else {
          alert.success("Requestor added", {
            onOpen: async () => await GetCustomerData(),
          });
        }
        handleRequestorClose();
      } else {
        updateLoader("requestor", true);
        result = await UpdateRequestor(data);
        updateLoader("requestor", false);
        if (result.data) {
          alert.success("requester updated", {
            onOpen: async () => await GetCustomerData(),
          });
        } else alert.success("Unable to update requester");
        handleRequestorClose();
      }
      setRequestorShow(false);
    }
  };

  const [errorRequestorLists, setRequestorError] = useState([]);
  //// Start Validation Function for saveRequestor
  function saveRequestorValidate() {
    let isValid = true;
    var errorRequestorList = [];
    /// Validation for customer name

    if (
      requestor.requestor_name === undefined ||
      requestor.requestor_name === ""
    ) {
      isValid = false;
      errorRequestorList.push("requestorName");
    }

    /// validation for requestorEmail
    if (
      requestor.requestor_email === undefined ||
      requestor.requestor_email === ""
    ) {
      isValid = false;
      errorRequestorList.push("requestorEmail");
    }

    /// validation for requestorPhone
    if (
      requestor.requestor_phone === undefined ||
      requestor.requestor_phone === ""
    ) {
      isValid = false;
      errorRequestorList.push("requestorPhone");
    }

    /// validation for requestorPassword
    if (
      requestor.requestor_id === 0 &&
      (requestor.requestor_password === undefined ||
        requestor.requestor_password === "")
    ) {
      isValid = false;
      errorRequestorList.push("requestorPassword");
    }

    setRequestorError(errorRequestorList);
    return isValid;
  }
  //// End Validation Function for saveRequestor

  async function deleteRequestor(id) {
    confirmAlert({
      title: "Delete",
      message: "Are you sure want to delete this requester?",
      buttons: [
        {
          label: "Yes",
          className: "yesbtn",
          onClick: async () => {
            await DeleteRequestor(id);
            alert.success("Requestor deleted", {
              onOpen: async () => await GetCustomerData(),
            });
          },
        },
        { label: "No", className: "nobtn" },
      ],
    });
  }

  async function deleteReport(id) {
    confirmAlert({
      title: "Delete",
      message: "Are you sure want to delete this report?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await DeleteCustomerReport(id);
            alert.success("Report deleted", {
              onOpen: async () => await GetCustomerData(),
            });
          },
        },
        { label: "No" },
      ],
    });
  }

  const saveReport = async (evt) => {
    evt.preventDefault();
    if (saveReportValidate()) {
      var data = {
        id: reportId,
        totalRows: 0,
        reportCustomerMappingId: reportMappingId,
        reportName: reportName,
        reportDescription: "",
        reportPrice: reportPrice,
        customPrice: reportCustomPrice,
        taxStatus: "",
        reportTemplateId: reportTemplate.id,
        customerId: customerId,
      };

      if (reportMappingId === 0) {
        updateLoader("report", true);
        var result = await AssignReportTemplate(data);
        if (result.data === 0)
          alert.error("Unable to add Report", {
            onClose: () => updateLoader("report", false),
          });
        else {
          alert.success("Report added", {
            onOpen: async () => await GetCustomerData(),
            onClose: () => updateLoader("report", false),
          });
        }
      } else {
        updateLoader("report", true);
        result = await AssignReportTemplate(data);
        if (result.data) {
          alert.success("Report updated", {
            onOpen: async () => await GetCustomerData(),
            onClose: () => updateLoader("report", false),
          });
        } else
          alert.error("Unable to update report", {
            onClose: () => updateLoader("report", false),
          });
      }
      setReportShow(false);
      handleReportClose();
    }
  };

  const [errorReportLists, setReportError] = useState([]);
  //// Validation Function for Report
  function saveReportValidate() {
    let isValid = true;
    var errorReportList = [];

    //console.log(reportTemplate.id);
    if (reportTemplate.id === 0) {
      isValid = false;
      errorReportList.push("reportTemplate");
    }

    //console.log(reportName);
    /// validation for reportName
    if (reportName === undefined || reportName === "") {
      isValid = false;
      errorReportList.push("reportName");
    }

    //console.log(reportCustomPrice);
    /// validation for reportCustomPrice
    if (reportPrice === 0 || reportPrice < 0) {
      isValid = false;
      errorReportList.push("reportPrice");
    }

    console.log(errorReportList);
    setReportError(errorReportList);
    return isValid;
  }

  const saveForm = async (e) => {
    e.preventDefault();
    if (saveFormValidate()) {
      var reqBody = {
        id: formId,
        totalRows: 0,
        formName: formName,
        formTemplateId: formTemplate.id,
        customerId: customerId,
      };

      if (formId === 0) {
        updateLoader("form", true);
        var result = await AssignFormTemplateToCustomer(reqBody);
        if (result.status === 200) {
          alert.success("Form assigned to customer", {
            onOpen: async () => await GetCustomerData(),
            onClose: () => updateLoader("form", false),
          });
        } else
          alert.error("Unable to assign form to customer", {
            onClose: () => updateLoader("form", false),
          });
      } else {
        updateLoader("form", true);
        result = await UpdateAssignedForm(reqBody);
        if (result.status === 200) {
          alert.success("Form updated", {
            onOpen: async () => await GetCustomerData(),
            onClose: () => updateLoader("form", false),
          });
        } else
          alert.error("Unable to update form", {
            onClose: () => updateLoader("form", false),
          });
      }
      setFormShow(false);
    }
  };

  const deleteAssignedForm = async (id) => {
    confirmAlert({
      title: "delete",
      message: "Are you sure want to remove assigned form?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            var result = await DeleteAssignedForm(id);
            if (result.status === 200) {
              alert.success("form deleted", {
                onOpen: () => GetCustomerData(),
              });
            } else alert.error("unable to delete form");
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const [errorFormLists, setFormError] = useState([]);
  /// Validation function for form
  function saveFormValidate() {
    let isValid = true;
    var errorFormList = [];

    if (formTemplate.id === 0) {
      isValid = false;
      errorFormList.push("formTemplate");
    }

    if (formName == null || formName === "") {
      isValid = false;
      errorFormList.push("formName");
    }

    setFormError(errorFormList);
    return isValid;
  }

  const showFormDetail = (id, name, templateid) => {
    setFormId(id);
    setFormName(name);
    let tmplt = formTemplateData.filter((x) => x.id == templateid);
    setFormTemplate(tmplt[0]);
    setFormShow(true);
  };

  const [errorAddDocumentsLists, setAddDocumentsError] = useState([]);
  //// Validation Function for Add Documents
  function saveAddDocumentsValidate() {
    let isValid = true;
    var errorAddDocumentsList = [];
    /// Validation for Add Documents
    if (docName === undefined || docName === "") {
      isValid = false;
      errorAddDocumentsList.push("docName");
    }
    if (docFile === "") {
      isValid = false;
      errorAddDocumentsList.push("docFile");
    }

    //console.log(errorAddDocumentsList);
    setAddDocumentsError(errorAddDocumentsList);
    return isValid;
  }

  const saveDoc = async (evt) => {
    evt.preventDefault();
    if (saveAddDocumentsValidate()) {
      var data = {
        id: 0,
        totalRows: 0,
        customerId: customerId,
        documentName: docName,
        documentPath: docFile,
      };
      updateLoader("document", true);
      var result = await AddCustomerDoc(data);
      if (result.data !== 0) {
        alert.success("Document added", {
          onOpen: async () => GetCustomerData(),
          onClose: () => updateLoader("document", false),
        });
      } else
        alert.error("Unable to add document", {
          onClose: () => updateLoader("document", false),
        });
      setDocShow(false);
    }
  };

  async function deleteDoc(docId) {
    confirmAlert({
      title: "Delete",
      message: "Are you sure want to delete this document/reference material?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await DeleteCustomerDoc(docId);
            alert.success("Document deleted successfully", {
              onOpen: async () => await GetCustomerData(),
            });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  async function DeleteCustomerRecord() {
    confirmAlert({
      title: "Delete",
      message: "Are you sure want to delete this Customer?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            updateLoader("customerDelete", true);
            var result = await DeleteCustomer(customerId);
            if (result.status === 200) {
              alert.success("Customer Deleted", {
                onClose: () => navigate("/Admin/Customers"),
              });
            } else {
              alert.error("Unable to delete customer");
              updateLoader("customerDelete", false);
            }
          },
        },
        { label: "No" },
      ],
    });
  }

  const handleEmailOnBlur = async (evt) => {
    if (evt === "") alert.info("Enter email");
    else {
      var isEmailExists = await checkRequesterEmail(evt);
      if (isEmailExists.data === true) {
        updateRequestor("requestor_email", "");
        alert.info("Email exists");
      }
    }
  };

  const [showReportList, setReportList] = useState(false);
  const handleReportTemplate = (item) => {
    setReportTemplate(item);
    setReportPrice(item.reportPrice);
    if (item.templateName.includes("Pdf Reports")) setReportList(true);
    else setReportList(false);
  };

  const filterData = (filter) => {
    const data = allReport.slice();
    return filterBy(data, filter);
  };

  const reportFilterChange = (e) => {
    setOldReportList(filterData(e.filter));
  };

  const handleCountryChange = async (e, indx) => {
    var cntry = e.value;
    var addrs = [...requestor.addresses];

    addrs[indx].country = {
      countryId: cntry.countryId,
      countryName: cntry.countryName,
    };
    addrs[indx].statelist = stateData.filter(
      (x) => x.countryId === cntry.countryId
    );
    addrs[indx].state = defaultState;

    updateRequestor("addresses", addrs);
  };

  const handleStateChange = (e, indx) => {
    var state = e.value;
    var addrs = [...requestor.addresses];

    addrs[indx].state = {
      stateId: state.stateId,
      stateName: state.stateName,
      countryId: state.countryId,
    };

    updateRequestor("addresses", addrs);
  };

  const handleAddressChange = (key, val, indx) => {
    var addrs = [...requestor.addresses];
    addrs[indx][key] = val;

    updateRequestor("addresses", addrs);
  };

  const handleAddressDelete = (indx) => {
    var addrs = [...requestor.addresses];
    var addrId = addrs[indx].address_id;

    if (addrId !== 0) {
      confirmAlert({
        title: "Delete Address",
        message: "Are you sure want to delete this address?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              await DeleteRequestorAddress(addrId, requestor.requestor_id);
              addrs[indx].is_deleted = true;
              updateRequestor("addresses", addrs);
            },
          },
          {
            label: "No",
          },
        ],
      });
    } else {
      addrs[indx].is_deleted = true;
      updateRequestor("addresses", addrs);
    }
  };

  const handleAddAddress = () => {
    var addrs = [...requestor.addresses];
    addrs.push(defaultAddress);

    updateRequestor("addresses", addrs);
  };

  const handleSaveAddress = async (e) => {
    e.preventDefault();
    var addrData = getRequestorAddresses();
    addrData = addrData.filter((x) => x.streetAddress != "");
    if (requestor.requestor_id != 0 && addrData.length > 0) {
      updateLoader("address", true);
      var result = await AddUpdateRequestorAddress(addrData);
      if (result) {
        updateLoader("address", false);
        getRequestorDetail(requestor.mapping_id);
        handleAddressClose();
      }
    } else handleAddressClose();
  };

  function getRequestorAddresses() {
    const addrList = requestor.addresses.filter((x) => !x.is_deleted);
    var addrData = [];
    if (addrList !== null && addrList.length > 0) {
      for (var addr of addrList) {
        var data = {
          id: addr.address_id,
          requestorId: requestor.requestor_id,
          streetAddress: addr.street_address,
          streetAddress2: addr.street_address2,
          addressCity: addr.city,
          addressState: addr.state.stateId,
          zipCode: addr.zipcode,
          country: addr.country.countryId,
          isDeleted: 0,
        };

        addrData.push(data);
      }
    }

    return addrData;
  }

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders mrg-btm">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>
                        {customerData.customer_first_name}{" "}
                        {customerData.customer_last_name}
                      </h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12} className="btn-right">
                    <Button
                      variant="dark"
                      type="button"
                      onClick={DeleteCustomerRecord}
                    >
                      {" "}
                      Delete Customer
                      <Loader
                        visible={showLoader.customerDelete}
                        ibutton={true}
                      />
                    </Button>
                  </Col>
                </Row>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="customer-detail-box">
                      <div className="customer-dt-list">
                        <span>Customer No.:</span> {customerData.customer_id}
                      </div>
                      <div className="customer-dt-list">
                        <span>Customer Name:</span>{" "}
                        {customerData.customer_first_name}{" "}
                        {customerData.customer_last_name}
                      </div>
                      <div className="customer-dt-list">
                        <span>Department:</span> {customerData.department_name}
                      </div>
                      <div className="customer-dt-list">
                        <span>Prepaid/Invoiced:</span>{" "}
                        {customerData.customer_subs_type === "0"
                          ? "Invoiced"
                          : customerData.customer_subs_type === "1"
                          ? "Prepaid"
                          : "Not Set"}
                      </div>
                      <div className="customer-dt-list">
                        <span>GST Exempt:</span>{" "}
                        {customerData.customer_gst_exempt === 0 ? "No" : "Yes"}
                      </div>
                      <div className="customer-dt-list">
                        <span>Membership Fee:</span>{" "}
                        {customerData.membership_fee ?? 0}
                      </div>
                      <div className="customer-dt-list">
                        <span>Membership Expiry Date:</span>{" "}
                        {dateFormat(
                          customerData.membership_expiry_date,
                          "mm/dd/yyyy"
                        )}
                      </div>
                      <div className="customer-dt-list">
                        <span>Service Fee:</span>{" "}
                        {customerData.service_fee ?? 0}%
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="add-materials">
                      <h2>
                        Documents/Reference Materials{" "}
                        <span
                          style={
                            customerData.is_archived
                              ? { display: "none" }
                              : { display: "inline-block" }
                          }
                        >
                          <button className="btn" onClick={handleDocShow}>
                            <AiIcons.AiFillFolderAdd />
                          </button>
                        </span>
                      </h2>
                      <ol>
                        {docData.map((doc) => (
                          <li>
                            <button
                              type="btn"
                              onClick={() =>
                                ShowCustomerDocument(doc.document_id)
                              }
                            >
                              {doc.document_name}{" "}
                            </button>
                            <span>
                              <button
                                onClick={() => deleteDoc(doc.document_id)}
                              >
                                <RiIcons.RiDeleteBin5Line />
                              </button>
                            </span>
                          </li>
                        ))}
                      </ol>
                    </div>
                  </Col>
                </Row>
                <Row className="Requester-box">
                  <h3>
                    Requester(s) :{" "}
                    <span
                      style={
                        customerData.is_archived
                          ? { display: "none" }
                          : { display: "inline-block" }
                      }
                    >
                      <button className="btn" onClick={handleRequestorShow}>
                        <AiIcons.AiFillFolderAdd />
                      </button>
                    </span>
                  </h3>
                  {customerData.is_archived ? (
                    <Grid
                      style={{ height: "220px" }}
                      data={requestorData}
                      resizable={true}
                    >
                      <GridColumn
                        field="requestor_name"
                        title="Requester Name"
                      />
                      <GridColumn
                        field="requestor_email"
                        title="Email Address"
                      />
                      <GridColumn field="invoice_email" title="Invoice Email" />
                      <GridColumn field="requestor_address" title="Address" />
                    </Grid>
                  ) : (
                    <Grid style={{ height: "220px" }} data={requestorData}>
                      <GridColumn
                        field="requestor_name"
                        title="Requester Name"
                      />
                      <GridColumn
                        field="requestor_email"
                        title="Email Address"
                      />
                      <GridColumn field="invoice_email" title="Invoice Email" />
                      <GridColumn
                        field="requestor_id"
                        title="Edit"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                getRequestorDetail(props.dataItem.mapping_id)
                              }
                            >
                              <RiIcons.RiEdit2Fill />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                      <GridColumn
                        field="requestor_email"
                        title="Password"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="button"
                              onClick={(e) =>
                                resetPassword(e, props.dataItem.requestor_email)
                              }
                              // disabled={enableButton}
                            >
                              <RiIcons.RiLockPasswordFill />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                      <GridColumn
                        field="requestor_id"
                        title="Delete"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                deleteRequestor(props.dataItem.mapping_id)
                              }
                            >
                              <RiIcons.RiDeleteBin5Line />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                    </Grid>
                  )}
                </Row>

                <Row className="ReportPrice-box">
                  <h3>
                    Reports/Pricing :{" "}
                    <span
                      style={
                        customerData.is_archived
                          ? { display: "none" }
                          : { display: "inline-block" }
                      }
                    >
                      <button className="btn" onClick={handleReportShow}>
                        <AiIcons.AiFillFolderAdd />
                      </button>
                    </span>
                  </h3>
                  {customerData.is_archived ? (
                    <Grid style={{ height: "220px" }} data={reportData}>
                      <GridColumn field="report_name" title="Report Name" />
                      <GridColumn field="template_name" title="Report Type" />
                      <GridColumn
                        field="report_custom_price"
                        title="Price"
                        width="100px"
                      />
                    </Grid>
                  ) : (
                    <Grid style={{ height: "220px" }} data={reportData}>
                      <GridColumn field="report_name" title="Report Name" />
                      <GridColumn field="template_name" title="Report Type" />
                      <GridColumn
                        field="report_custom_price"
                        title="Price"
                        width="100px"
                      />
                      <GridColumn
                        field="report_customer_mapping_id"
                        title="Edit"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                getReportDetail(
                                  props.dataItem.report_customer_mapping_id
                                )
                              }
                            >
                              <RiIcons.RiEdit2Fill />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                      <GridColumn
                        field="report_id"
                        title="Delete"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                deleteReport(
                                  props.dataItem.report_customer_mapping_id
                                )
                              }
                            >
                              <RiIcons.RiDeleteBin5Line />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                    </Grid>
                  )}
                </Row>

                <Row className="forms-box">
                  <h3>
                    Forms :{" "}
                    <span
                      style={
                        customerData.is_archived
                          ? { display: "none" }
                          : { display: "inline-block" }
                      }
                    >
                      <button className="btn" onClick={handleFormShow}>
                        <AiIcons.AiFillFolderAdd />
                      </button>
                    </span>
                  </h3>
                  {customerData.is_archived ? (
                    <Grid style={{ height: "220px" }} data={formData}>
                      <GridColumn field="form_name" title="Form Name" />
                      <GridColumn field="template_name" title="Form Template" />
                    </Grid>
                  ) : (
                    <Grid style={{ height: "220px" }} data={formData}>
                      <GridColumn field="form_name" title="Form Name" />
                      <GridColumn field="template_name" title="Form Template" />
                      <GridColumn
                        field="customer_form_mapping_id"
                        title="Edit"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                showFormDetail(
                                  props.dataItem.customer_form_mapping_id,
                                  props.dataItem.form_name,
                                  props.dataItem.form_template_id
                                )
                              }
                            >
                              <RiIcons.RiEdit2Fill />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                      <GridColumn
                        field="customer_form_mapping_id"
                        title="Delete"
                        width="100px"
                        cell={(props) => (
                          <td className="req">
                            <button
                              type="btn"
                              onClick={() =>
                                deleteAssignedForm(
                                  props.dataItem.customer_form_mapping_id
                                )
                              }
                            >
                              <RiIcons.RiDeleteBin5Line />
                            </button>
                          </td>
                        )}
                      ></GridColumn>
                    </Grid>
                  )}
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>

      {/* Add Edit Requester Modal */}
      <Modal
        centered
        show={requestorShow}
        onHide={handleRequestorClose}
        className="editreqmain"
      >
        <Modal.Body className="invest-modal editreqestor-modal">
          <Form onSubmit={saveRequestor}>
            <h2>
              {requestor.requestor_id === 0
                ? "Add Requester"
                : "Edit Requester"}
            </h2>
            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Requester Name:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    value={requestor.requestor_name}
                    onChange={(e) =>
                      updateRequestor("requestor_name", e.target.value)
                    }
                    className={
                      errorRequestorLists.includes("requestorName")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Email Address:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  {requestor.requestor_id === 0 ? (
                    <Form.Control
                      type="email"
                      value={requestor.requestor_email}
                      onChange={(e) =>
                        updateRequestor("requestor_email", e.target.value)
                      }
                      className={
                        errorRequestorLists.includes("requestorEmail")
                          ? "is-invalid"
                          : ""
                      }
                      onBlur={(e) => handleEmailOnBlur(e.target.value)}
                    />
                  ) : (
                    <Form.Control
                      type="email"
                      readOnly="readOnly"
                      style={{ backgroundColor: "#f5f5f5" }}
                      value={requestor.requestor_email}
                      onChange={(e) =>
                        updateRequestor("requestor_email", e.target.value)
                      }
                      className={
                        errorRequestorLists.includes("requestorEmail")
                          ? "is-invalid"
                          : ""
                      }
                    />
                  )}
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label>Invoice Email:</Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="phone"
                    value={requestor.invoice_email}
                    onChange={(e) =>
                      updateRequestor("invoice_email", e.target.value)
                    }
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Phone Number:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="phone"
                    value={requestor.requestor_phone}
                    onChange={(e) =>
                      updateRequestor("requestor_phone", e.target.value)
                    }
                    className={
                      errorRequestorLists.includes("requestorPhone")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>
            {requestor.requestor_id === 0 ? (
              <Form.Group className="mb-3" controlId="formBasicText">
                <Row>
                  <Col lg={5} md={12} className="generate-btn">
                    <Form.Label className="field-required">
                      Password:
                    </Form.Label>
                    <Button
                      type="button"
                      variant="link"
                      onClick={() =>
                        updateRequestor("requestor_password", generate())
                      }
                    >
                      Generate Password
                    </Button>
                  </Col>
                  <Col lg={7} md={12}>
                    <Form.Control
                      type="password"
                      value={requestor.requestor_password}
                      onChange={(e) =>
                        updateRequestor("requestor_password", e.target.value)
                      }
                      className={
                        errorRequestorLists.includes("requestorPassword")
                          ? "is-invalid"
                          : ""
                      }
                    />
                  </Col>
                </Row>
              </Form.Group>
            ) : (
              ""
            )}
            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={12} md={12} className="generate-btn">
                  <Button
                    type="button"
                    variant="link"
                    onClick={handleAddressShow}
                  >
                    Add/Update Address
                  </Button>{" "}
                  (Please reopen requestor edit to reflect newly made changes)
                </Col>
              </Row>
            </Form.Group>
            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">
                  Save <Loader visible={showLoader.requestor} ibutton={true} />
                </Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button type="button" onClick={handleRequestorClose}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Add Edit Reports Modal */}
      <Modal centered show={reportShow} onHide={handleReportClose}>
        <Modal.Body className="invest-modal editreports-modal">
          <Form onSubmit={saveReport}>
            <h2>{reportId === 0 ? "Add Report" : "Edit Report"}</h2>

            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Template:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <DropDownList
                    style={{ width: "100%" }}
                    data={reportTemplateData}
                    textField="templateName"
                    dataItemKey="id"
                    defaultItem={defaultReportTemplate}
                    value={reportTemplate}
                    onChange={(e) => handleReportTemplate(e.value)}
                    disabled={reportId === 0 ? false : true}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">Customer:</Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    value={
                      customerData.customer_first_name +
                      " " +
                      (customerData.customer_last_name == null
                        ? ""
                        : customerData.customer_last_name)
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Name:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  {showReportList ? (
                    <ComboBox
                      style={{ width: "100%" }}
                      data={oldReportList}
                      textField="reportName"
                      dataItemKey="id"
                      placeholder="Choose Report..."
                      value={report}
                      onChange={(e) => handleReport(e.value)}
                      filterable={true}
                      onFilterChange={reportFilterChange}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      value={reportName}
                      onChange={(e) => setReportName(e.target.value)}
                      className={
                        errorReportLists.includes("reportName")
                          ? "is-invalid"
                          : ""
                      }
                    />
                  )}
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Report Price:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    value={reportPrice}
                    onChange={(e) => setReportPrice(e.target.value)}
                    className={
                      errorReportLists.includes("reportPrice")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">
                  {reportId === 0 ? "Assign" : "Update"}
                  <Loader visible={showLoader.report} ibutton={true} />
                </Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button type="button" onClick={handleReportClose}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Add Documents Model */}
      <Modal centered show={docShow} onHide={handleDocClose}>
        <Modal.Body className="invest-modal adddocuments-modal">
          <Form onSubmit={saveDoc}>
            <h2>Add Documents</h2>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Document Name:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="text"
                    value={docName}
                    onChange={(e) => setDocName(e.target.value)}
                    className={
                      errorAddDocumentsLists.includes("docName")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-5" controlId="formBasicText">
              <Row>
                <Col lg={5} md={12}>
                  <Form.Label className="field-required">
                    Upload File:
                  </Form.Label>
                </Col>
                <Col lg={7} md={12}>
                  <Form.Control
                    type="file"
                    onChange={handleFileChange}
                    className={
                      errorAddDocumentsLists.includes("docFile")
                        ? "is-invalid"
                        : ""
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">
                  Upload <Loader visible={showLoader.document} ibutton={true} />
                </Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button onClick={handleDocClose}>Cancel</Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      {/*Add Form Model */}
      <Modal centered show={formShow} onHide={handleFormClose}>
        <Modal.Body className="invest-modal">
          <h2>{formId === 0 ? "Add Form" : "Edit Form"}</h2>
          <Form onSubmit={saveForm}>
            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Form Template:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <DropDownList
                    style={{ width: "100%" }}
                    data={formTemplateData}
                    textField="templateName"
                    dataItemKey="id"
                    defaultItem={defaultFormTemplate}
                    value={formTemplate}
                    onChange={(e) => setFormTemplate(e.value)}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicSelect">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Customer:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Control
                    type="text"
                    value={
                      customerData.customer_first_name +
                      " " +
                      (customerData.customer_last_name == null
                        ? ""
                        : customerData.customer_last_name)
                    }
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicText">
              <Row>
                <Col lg={4} md={12}>
                  <Form.Label>Form Name:</Form.Label>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Control
                    type="text"
                    placeholder="Custom Form Name"
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                    className={
                      errorFormLists.includes("formName") ? "is-invalid" : ""
                    }
                    required
                  />
                </Col>
              </Row>
            </Form.Group>

            <Row className="ordbtn">
              <Col lg={6} md={12} className="btorng">
                <Button type="submit">
                  {formId === 0 ? "Assign" : "Update"}
                  <Loader visible={showLoader.form} ibutton={true} />
                </Button>
              </Col>
              <Col lg={6} md={12} className="btgry">
                <Button onClick={handleFormClose}>Cancel</Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      {/*Add Edit Requestor Address */}
      <Modal
        show={addressShow}
        onHide={handleAddressClose}
        className="addreport-popmodal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add/Update Requestor Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              {requestor.addresses.map((addr, indx) =>
                addr.is_deleted ? (
                  ""
                ) : (
                  <div key={indx}>
                    <Row>
                      <Col lg={4} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>Street Address</Form.Label>
                                </Col>
                                <Col lg={9} md={12}>
                                  <Form.Control
                                    as="textarea"
                                    placeholder="Street Address"
                                    value={addr.street_address}
                                    onChange={(e) =>
                                      handleAddressChange(
                                        "street_address",
                                        e.target.value,
                                        indx
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>Street Address2</Form.Label>
                                </Col>
                                <Col lg={9} md={12}>
                                  <Form.Control
                                    as="textarea"
                                    placeholder="Street Address2"
                                    value={addr.street_address2}
                                    onChange={(e) =>
                                      handleAddressChange(
                                        "street_address2",
                                        e.target.value,
                                        indx
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>Country</Form.Label>
                                </Col>
                                <Col lg={9} md={12}>
                                  <DropDownList
                                    style={{ width: "100%" }}
                                    data={countryData}
                                    textField="countryName"
                                    dataItemKey="countryId"
                                    defaultItem={defaultCountry}
                                    value={addr.country}
                                    onChange={(e) =>
                                      handleCountryChange(e, indx)
                                    }
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>State</Form.Label>
                                </Col>
                                <Col lg={9} md={12}>
                                  <DropDownList
                                    style={{ width: "100%" }}
                                    data={addr.statelist}
                                    textField="stateName"
                                    dataItemKey="stateId"
                                    defaultItem={defaultState}
                                    value={addr.state}
                                    onChange={(e) => handleStateChange(e, indx)}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>City</Form.Label>
                                </Col>
                                <Col lg={9} md={12}>
                                  <Form.Control
                                    type="text"
                                    placeholder="City"
                                    value={addr.city}
                                    onChange={(e) =>
                                      handleAddressChange(
                                        "city",
                                        e.target.value,
                                        indx
                                      )
                                    }
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3} md={12}>
                        <div className="cards-text">
                          <div className="cards-list-group">
                            <div className="cards-list-item">
                              <Row>
                                <Col lg={3} md={12}>
                                  <Form.Label>Zip Code</Form.Label>
                                </Col>
                                <Col lg={7} md={12}>
                                  <Form.Control
                                    type="text"
                                    placeholder="zip code"
                                    value={addr.zipcode}
                                    onChange={(e) =>
                                      handleAddressChange(
                                        "zipcode",
                                        e.target.value,
                                        indx
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={1} md={12}>
                                  <div className="assign-delt">
                                    <Link
                                      to={`/Admin/CustomerViewDetails?id=${customerId}`}
                                      type="button"
                                      className="button remove"
                                      onClick={() => handleAddressDelete(indx)}
                                    >
                                      <MdIcons.MdDeleteForever />
                                    </Link>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )
              )}

              <Row>
                <div className="add-report-btn mb-3">
                  <Link
                    to={`/Admin/CustomerViewDetails?id=${customerId}`}
                    onClick={() => handleAddAddress()}
                  >
                    Add Address
                  </Link>
                </div>
              </Row>
            </div>
          </Form>
        </Modal.Body>
        {requestor.addresses.length > 0 && (
          <Modal.Footer>
            <div className="btorng">
              <Button type="button" onClick={(e) => handleSaveAddress(e)}>
                Save <Loader visible={showLoader.address} />
              </Button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
